export const reducerCases = {
  IS_SHOW_CUSTOM_COLUMNS: 'IS_SHOW_CUSTOM_COLUMNS',
  SET_AUTOMATION_RULES_METADATA: 'SET_AUTOMATION_RULES_METADATA',
}
